export default {
    login_verification_text: "Привет {user}, мы отправили код подтверждения на {email}. Введите код для входа",
    code_resent: "Код подтверждения успешно отправлен повторно",
}
